
import axios from "axios";
import * as d3 from "d3";
import { numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (chart.axisLabelFontSize ) + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(res => {
        let data = res.data
        var hoverLine = false;
        var landscape = true;

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + 2 * chart.margin.left + "," + chart.margin.top + ")");

        //x axis lable xscale
        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom - 6 * chart.axisLabelDistance)
            .attr('fill', fontColor)
            .attr('font-size', fontSize)
            .text(chart.x1AxisDisplayName)
        //y axis labelline
        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left - 20 * chart.axisLabelDistance)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .attr('fill', fontColor)
            .attr('font-size', fontSize)
            .style('text-anchor', 'middle')
            .text(chart.y1AxisDisplayName)

        function sortBy(data, attribute, order)//data :data ,attribute: dim1_name,order: 1 or -1
        {
            data.sort(function (a, b) {
                if (a[attribute] < b[attribute]) return -1 * order; // ascending order
                if (a[attribute] > b[attribute]) return 1 * order; //descending order
                return 0;
            });
        }

        // need to rewrite so start, min, lowest are the same
        var classToPos = {
            "lollipop-start": "metric1",
            "lollipop-average": "metric2",
            "lollipop-end": "metric3"
        }


        // Append div
        var y1tip = d3.select('body')
            .append("div")
            .attr("class", "tooltip")
            .style('position', 'relative')
            .style('line-height', '1')
            .style('padding', '12px')
            .style('background', 'white')
            .style('border-radius', '5px')
            .style('position', 'absolute')
            .style('border-width', '.5px')
            .style('border-style', 'groove')

        var metric1ColorScale = {
            median: "black",
            average: "blue",
            max: "grey"
        };

        var x1Scale = d3.scaleLinear().range([0, chart.width]);
        var y1Scale = d3.scaleBand().range([0, chart.height])
            .paddingInner(0.5).paddingOuter(0.7);

        var lineGenerator = d3.line();
        var lineGenarator2 =d3.line();


        var lollipopLinePath = function (d) {
            return lineGenerator([[x1Scale(d.metric1), 0], [x1Scale(d.metric2), 0]]);
        };

        var lollipopLinePath2=function(d){
            return lineGenarator2([[x1Scale(d.metric2),0],[x1Scale(d.metric3),0]]);
        }

        var selectionLine, lollipops, yAxisGroup, xAxisGroup, lollipopsGroup;
        var startCircles, averageCircles, endCircles;

        // Make global for now
        var payRatios;
        payRatios = data

        // use -1 to flip ordering
        sortBy(payRatios, "dim1_name", 1);

        x1Scale.domain([0, d3.max(payRatios, function (d) {
            return d.metric3
        })]);
        x1Scale.nice();
        y1Scale.domain(payRatios.map(function (d) {
            return d.dim1_name
        }));

        var x1AxisLabel = d3.axisBottom().scale(x1Scale).tickFormat(d => numberFormat(d));
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickSize(0);

        yAxisGroup = svg.append("g").attr("class", "y-axis-group");

        // at loading time
        yAxisGroup.append("g")
            .attr("class", "y-axis")
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size',axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr("transform", "translate(-12, 0)")
           .select(".domain")
            .attr("opacity", 0)



        xAxisGroup = svg.append("g").attr("class", "x-axis-group");

        xAxisGroup.append("g")
            .attr("class", "x-axis")
            .call(x1AxisLabel)
            .style('font-size', axisLabelFontSize)
            .attr("transform", "translate(0," + chart.height + ")")


        selectionLine = xAxisGroup.append("g")
            .attr("class", "interactive")
            .append("path")
            .attr("class", "selection-line")
            .attr("d", () => {
                return lineGenerator([[chart.width / 2, 0], [chart.width / 2, chart.height]])

            })
            .attr("opacity", 0);

        lollipopsGroup = svg.append("g").attr("class", "lollipops");

        lollipops = lollipopsGroup.selectAll("g")
            .data(payRatios)
            .enter()
            .append("g")
            .attr("class", "lollipop")
            .attr("transform", (d) => "translate(0," + (y1Scale(d.dim1_name) + (y1Scale.bandwidth() / 2) + ")"))


        // line color

        lollipops.append("path")
            .attr("class", "lollipop-line")
            .attr("d", lollipopLinePath)
            .style("stroke","Blue")

        lollipops.append("path")
            .attr("class","lollipop-line")
            .attr("d",lollipopLinePath2)
            .style("stroke","Grey")

        startCircles = lollipops.append("circle")
            .attr("class", "lollipop-start")
            .attr("r", 5)
            .attr("cx", (d) => {
                return x1Scale(d.metric1);
            })
            .style("fill",metric1ColorScale.median)
            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)

        averageCircles = lollipops.append("circle")
            .attr("class", "lollipop-average")
            .attr("r", function (d) {
                if (d.metric2 === "N/A") {
                    return 0;
                } else {
                    return 5;
                }
            })
            .attr("cx", function (d) {
                if (d.metric2 === "N/A") {
                    return 0;
                } else {
                    return x1Scale(d.metric2);
                }
            })
            .style("fill",metric1ColorScale.average)

            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)

        endCircles = lollipops.append("circle")
            .attr("class", "lollipop-end")
            .attr("r", 5)
            .attr("cx", (d) => {
                console.log("metric3",d.metric3)
                return x1Scale(d.metric3)
            })
            .style("fill",metric1ColorScale.max)
            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)

        console.log(startCircles, averageCircles, endCircles)

        function showLabel() {
            var selection = d3.select(this);
            var pos = classToPos[selection.attr("class")];
            var data = d3.select(this.parentNode).datum();

            // Set opacity for all  circles and lines to create a blur effect
            svg.selectAll(".lollipop-line, .lollipop-start, .lollipop-average, .lollipop-end")
                .style("stroke-opacity", 0.2)
                .style("fill-opacity", 0.2);

            d3.select(this.parentNode)
                .selectAll(".lollipop-line, .lollipop-start, .lollipop-average, .lollipop-end")
                .style("stroke-opacity", 1)
                .style("fill-opacity", 1);

            y1tip.transition()
                .duration(100)
                .style("opacity", 0.9);

            y1tip.html(data[pos])
                .style("left", (d3.event.pageX - 30) + "px")
                .style("top", (d3.event.pageY - 40) + "px")
                .style("background-color", metric1ColorScale);

            if (hoverLine) {
                selectionLine.attr("d", function () {
                    if (landscape) {
                        return lineGenerator([[x1Scale(data[pos]), 0], [x1Scale(data[pos]), chart.height]]);
                    } else {
                        return lineGenerator([[0, x1Scale(data[pos])], [chart.width, x1Scale(data[pos])]]);
                    }
                })
                    .attr("opacity", 0.75);
            }
        }



        function moveLabel() {
            y1tip.style("left", (d3.event.pageX - 30) + "px")
                .style("top", (d3.event.pageY - 40) + "px")
        }

        function hideLabel() {
            y1tip.transition().duration(200).style("opacity", 0);


            svg.selectAll(".lollipop-line,.lollipop-start, .lollipop-average, .lollipop-end")
                .style("stroke-opacity", 1)
                .style("fill-opacity", 1);


            selectionLine.attr("opacity", 0);
        }
    });
}




